import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

export default class FieldError extends Component {
	render() {
		const { meta } = this.props;

		if ( !meta.touched || !meta.error) {
			return null;
		}

		const tooltip = <Tooltip bsClass="error-tooltip tooltip" id="tooltip">{ meta.error }</Tooltip>;

		return (
			<OverlayTrigger placement="bottom" overlay={tooltip} trigger={['hover', 'focus', 'click']}>
				<i className="validate-icon i-apli-important"></i>
			</OverlayTrigger>
		);
	}
}

FieldError.propTypes = {
	meta: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/common/field-error.js